/**
 * Common styling for form field components to ensure consistency across the application
 */

export const fieldLabelStyle = {
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  fontSize: '0.875rem',
  fontWeight: 500,
  letterSpacing: '0.1px'
};

export default {
  fieldLabelStyle
};
